module.exports = __webpack_public_path__ + "img/744.55db0946.jpg";